import NoPublicationComponent from "./NoPublicationComponent";

export default NoPublicationComponent;